export default {
  API_BASE_URL: 'http://localhost:15700',
  S3_PROXY_BASE_URL: 'http://localhost:16000',
  LOG_LEVEL: 0,
}
